import { useCallback, useEffect, useState } from "react";
import type { Faq3Category } from "./viewModel";

/**
 * Keeps a stable selected category id; resets to first when list changes or id disappears.
 */
export function useFaq3Selection(categories: Faq3Category[]) {
  const [categoryId, setCategoryId] = useState<number | null>(
    () => categories[0]?.id ?? null,
  );

  useEffect(() => {
    if (categories.length === 0) {
      setCategoryId(null);
      return;
    }
    const stillThere = categoryId != null && categories.some((c) => c.id === categoryId);
    if (!stillThere) setCategoryId(categories[0].id);
  }, [categories, categoryId]);

  const selected = categories.find((c) => c.id === categoryId) ?? null;
  const items = selected?.items ?? [];

  const selectCategory = useCallback((id: number) => {
    setCategoryId(id);
  }, []);

  return { categoryId, selectCategory, selected, items };
}
